import { render, staticRenderFns } from "./QnaForm.vue?vue&type=template&id=37da0f53&scoped=true&"
import script from "./QnaForm.vue?vue&type=script&lang=js&"
export * from "./QnaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37da0f53",
  null
  
)

export default component.exports